import * as tslib_1 from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Card, Checkbox, Button } from '@/components/UIComponents/index';
import store from "@/store";
import { FullCalendarEvent as Event } from "@/API/Models/Account/FullCalendarEvent";
/* For calendar */
var moment = require('moment');
import { Calendar } from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
let ClientCalendarViewModel = class ClientCalendarViewModel extends Vue {
    constructor() {
        super();
        this.myReservations = new Array();
        this.myEvents = new Array();
    }
    initCalendar() {
        let calendarEl = document.getElementById('fullCalendar');
        let calendar = new Calendar(calendarEl, {
            plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin,],
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek'
            },
            timeZone: 'America/New_York',
            defaultDate: moment().format('YYYY-MM-DD'),
            navLinks: true,
            editable: false,
            eventLimit: true,
            events: this.getMyEvents
        });
        calendar.render();
    }
    handleReservationView(index, reservation) {
        window.open(reservation.redirectUrl, "_blank");
    }
    async getMyEvents(info, successCallback, failureCallback) {
        let myEvents = new Array();
        try {
            // @ts-ignore
            this.myReservations = await ReservationDAO.getUpcomingReservations(store.state.oidcStore.access_token);
            for (let index = 0; index < this.myReservations.length; index++) {
                let newEvent = new Event();
                newEvent.copyFromReservation(this.myReservations[index]);
                myEvents.push(newEvent);
            }
        }
        catch (error) {
            console.log('Failed the upcoming reservations call. ' + error);
            failureCallback(error);
        }
        successCallback(myEvents);
    }
    async mounted() {
        if (process.env.VUE_APP_ENV === "DEV") {
            console.log('Local development, getting access token for test user');
            // @ts-ignore
            store.state.oidcStore.access_token = await Identity.getUserAccessToken('dlight20@gmail.com', 'Smokey20');
        }
        this.initCalendar();
    }
};
ClientCalendarViewModel = tslib_1.__decorate([
    Component({
        components: {
            [Card.name]: Card,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button,
        }
    })
], ClientCalendarViewModel);
export default ClientCalendarViewModel;
